// `forecast` query-param codec for focusing a single forecast (#146).
// Notification emails link to `${baseUrl}/?forecast=<clientId>`. Pure (no React /
// no window) so it unit-tests in isolation, mirroring compareUrl.js. These are the
// low-level primitives; the single navigational entry point that composes them
// (alongside the compare codec) is `lib/view/urlState.ts` (EPIC #157 Lane E1).

// Read the `forecast` query param — a forecast id — from a search string, or null
// when absent/empty. The id is the persisted server `forecastId` for links the
// view mirror writes, or a legacy client run id for older email links; callers
// resolve either id-space (see viewStateActions / the boot deep-link apply).
export function readForecastParam(search) {
  const v = new URLSearchParams(search || "").get("forecast");
  const id = v && v.trim();
  return id || null;
}

// Return a new search string ("?..." or "") with `forecast` set to `id`
// (or removed when `id` is falsy), leaving other params untouched. The write
// half of readForecastParam — lets the view-state mirror keep ?forecast= in
// sync with the focused forecast (and clear it when nothing is focused).
export function writeForecastToSearch(search, id) {
  const p = new URLSearchParams(search || "");
  if (id) p.set("forecast", id);
  else p.delete("forecast");
  const s = p.toString();
  return s ? `?${s}` : "";
}
